import { Col } from 'antd';
import moment from 'moment';
import React from 'react';
import { Text } from '@good/components';
export const TmMgmtCreatedOnColumn = ({ createdOn }: { createdOn: Date }) => (
  <Col span={4}>
    <Text>{moment(createdOn).format('DD MMM YYYY')}</Text>
  </Col>
);
